import BaseType from "./BaseType";
import Scenes from "oc-threejs/Scenes";
import AGriff from "../arrangement/Griff";
import { v3 } from "oc-threejs/short3";

export default class UiSphere extends BaseType(THREE.Group) {
    constructor(vsData) {
        super(vsData);
        this.tapable = true;
    }

    vsUpdate() {
        if (this.isVsChanged("size")) {
            Scenes.empty(this);
            this.createSphere();
        }
        this.copyMatrix(this.vsData.matrix);
    }

    createSphere() {
        const map = new THREE.TextureLoader().load(APP.settings.wkfgContentBaseUrl + "img/add.svg");
        const spriteMaterial = new THREE.SpriteMaterial({ map: map, opacity: 0.5 });
        const sprite = new THREE.Sprite(spriteMaterial);
        sprite.scale.set(this.vsData.diameter, this.vsData.diameter, this.vsData.diameter)
        this.add(sprite);
    }

    onTap() {
        this.vsData.onTap();
    }
}
